export default [
    {
        path: 'paciente-busca',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-paciente-busca' */
            '@/views/pronto-atendimento/paciente-busca/Index'
        ),
        redirect: 'paciente-busca/index',
        children: [
            {
                name: 'pronto-atendimento-paciente-busca-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-paciente-busca' */
                    '@/views/pronto-atendimento/paciente-busca/List.vue'
                ),
            },
        ],
    },
]